import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "../../primitives/drawer";
import { Button } from "../../primitives/button";
import { AccountMenuItem } from "./AccountMenuItem";
import version from "@/config/version";

export default function AccountMenuDrawer({
  items,
  trigger,
}: {
  items: AccountMenuItem[];
  trigger: React.ReactNode;
}) {
  return (
    <Drawer>
      <DrawerTrigger className="flex self-center">{trigger}</DrawerTrigger>
      <DrawerContent aria-describedby="account-menu" className="px-4">
        <DrawerHeader />
        <DrawerTitle />
        <DrawerDescription />
        <DrawerFooter>
          {items.map(({ label, onClick, variant, disabled }) => (
            <DrawerClose asChild key={label}>
              <Button
                className="flex items-center gap-3 bg-accent text-base text-accent-foreground"
                variant={variant}
                onClick={onClick}
                disabled={disabled}
              >
                {label}
              </Button>
            </DrawerClose>
          ))}
          <code className="pt-2 text-center text-xs text-foreground/30">
            {version}
          </code>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
